/**
 * Strip LLM/DB null-sentinels so the UI never shows the literal word "null".
 * AD-2343: music-only scripts were persisted with hook === "null".
 */
export function isUsableScriptText(value: string | null | undefined): boolean {
  if (value == null) return false
  const trimmed = value.trim()
  if (trimmed.length === 0) return false
  const lower = trimmed.toLowerCase()
  return lower !== "null" && lower !== "undefined"
}

/**
 * Prefer a real hook; fall back to concept; then a translated untitled label.
 */
export function getScriptDisplayTitle(
  script: { hook: string | null; concept: string | null },
  untitled: string,
): string {
  if (isUsableScriptText(script.hook)) return script.hook!.trim()
  if (isUsableScriptText(script.concept)) return script.concept!.trim()
  return untitled
}
